/* Cloofs – Productslider / tabbladen (sections/cloofs-product-tabs.liquid)
   Tabbladen wisselen, voortgangslijn, link naar collectie en thema-editor. Slepen met de muis en de voortgangslijn
   als schuifbalk: assets/cloofs-slider.js. Geen afhankelijkheden. */
if (!customElements.get('cloofs-product-tabs')) {
  customElements.define(
    'cloofs-product-tabs',
    class CloofsProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.link = this.querySelector('[data-tabs-link]');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const step = event.key === 'ArrowRight' ? 1 : -1;
            const next = (index + step + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });

        this.tracks = Array.from(this.querySelectorAll('[data-track]'));
        this.tracks.forEach((track) => {
          track.addEventListener('scroll', () => this.progress(track), { passive: true });
          this.progress(track);
        });
        this.onResize = () => this.tracks.forEach((track) => this.progress(track));
        window.addEventListener('resize', this.onResize, { passive: true });

        this.onBlockSelect = (event) => {
          const index = this.tabs.findIndex((tab) => tab.id === 'Tab-' + event.detail.blockId);
          if (index > -1) this.select(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.onResize);
      }

      progress(track) {
        const bar = track.parentElement.querySelector('[data-progress]');
        if (!bar) return;
        const total = track.scrollWidth || 1;
        const width = Math.min(100, (track.clientWidth / total) * 100);
        const left = Math.min(100 - width, (track.scrollLeft / total) * 100);
        bar.style.width = width + '%';
        bar.style.left = left + '%';
        bar.parentElement.hidden = width >= 99;
      }

      hydrate(panel) {
        const template = panel.querySelector('template[data-tab-content]');
        if (template) template.replaceWith(template.content.cloneNode(true));
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !active;
          if (active) {
            this.hydrate(panel);
            const track = panel.querySelector('[data-track]');
            if (track) { track.scrollLeft = 0; this.progress(track); }
          }
        });
        const url = this.tabs[index] && this.tabs[index].dataset.url;
        if (this.link && url) this.link.href = url;
      }
    }
  );
}
